import { PopupEvent } from 'leaflet'
import React, { useEffect } from 'react'
import { useMap } from 'react-leaflet'

// Prevent default navigation when closing Leaflet popups
export const PopupCloseHrefFix: React.FC = () => {
  const map = useMap()
  useEffect(() => {
    const onPopupOpen = (e: PopupEvent) => {
      const container = e.popup?.getElement?.()

      if (!container) return

      const btn = container.querySelector('.leaflet-popup-close-button')

      if (btn) {
        btn.removeAttribute('href');
        (btn as HTMLElement).style.cursor = 'pointer'
      }
    }
    map.on('popupopen', onPopupOpen)

    return () => { map.off('popupopen', onPopupOpen) }
  }, [map])

  return null
}
